import React from 'react';
import { IconProps } from '../types';
import Theme from '../../../components-library/Theme';

export default function CopyIcon({ className, color }: IconProps) {
  return (
    <svg className={className ?? 'h-3 w-3'} viewBox="0 0 14 16" fill="none">
      <path
        d="M4.99922 12.8C4.55922 12.8 4.18255 12.6433 3.86922 12.33C3.55589 12.0167 3.39922 11.64 3.39922 11.2V1.6C3.39922 1.16 3.55589 0.783333 3.86922 0.47C4.18255 0.156667 4.55922 0 4.99922 0H12.1992C12.6392 0 13.0159 0.156667 13.3292 0.47C13.6426 0.783333 13.7992 1.16 13.7992 1.6V11.2C13.7992 11.64 13.6426 12.0167 13.3292 12.33C13.0159 12.6433 12.6392 12.8 12.1992 12.8H4.99922ZM4.99922 11.2H12.1992V1.6H4.99922V11.2ZM1.79922 16C1.35922 16 0.982552 15.8433 0.669219 15.53C0.355885 15.2167 0.199219 14.84 0.199219 14.4V3.2H1.79922V14.4H10.5992V16H1.79922Z"
        fill={color ?? Theme.color.gray['100']}
      />
    </svg>
  );
}
